import { urlConfig } from '@config/url.config';
import { IRawTelemetry } from '@core/Telemetry';
import AbstractAPI from './Abstract.api';

interface IGetDeviceTelemetryReq {
    token: string;
    imei: string;
    from?: number;
    to?: number;
    limit?: number;
    offset?: number;
    filter?: string[];
    active: boolean;
}

interface IGetDeviceTelemetryRes {
    total: number;
    telemetry: IRawTelemetry[];
    deviceold: boolean
}

export class TelemetryAPI extends AbstractAPI {
    async getDeviceTelemetry({
        token,
        imei,
        from,
        to,
        limit,
        offset,
        filter,
        active
    }: IGetDeviceTelemetryReq) {
        const pathname = 'telemetry/get';
        const method = 'POST';
        const body: IGetDeviceTelemetryReq = {
            token,
            imei,
            active,
            offset: 0,
        };

        if (from) body.from = from;
        if (to) body.to = to;
        if (limit) body.limit = limit;
        if (offset) body.offset = offset;
        if (filter && filter.length) body.filter = filter;
        try {
            return await this._request<IGetDeviceTelemetryRes>(
                pathname,
                method,
                body,
            );
        } catch (e) {
            throw new Error(e);
        }
    }

}

export const telemetryAPI = new TelemetryAPI(urlConfig);
